import { Box, Stack, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';


interface PageTitleProps {
  children: React.ReactNode;
  subTitle?: React.ReactNode;
}


function PageTitle(props: PageTitleProps) {
  const theme = useTheme();
  return (
    <Box>
      <Stack>
        <Typography
          variant="displaySM"
          sx={{ fontWeight: 600 }}>
          {props.children}
        </Typography>
        <Typography color={theme.palette.custom.gray[600]}
          variant="textMD"
          sx={{ fontWeight: 400 }}>
          {props.subTitle}
        </Typography>
      </Stack>
    </Box>
  );
}

export default PageTitle;